/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The EmailsCheckSettingsImport model module.
 * @module model/EmailsCheckSettingsImport
 * @version 1.0.0
 */
export class EmailsCheckSettingsImport {
  /**
   * Constructs a new <code>EmailsCheckSettingsImport</code>.
   * @alias module:model/EmailsCheckSettingsImport
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>EmailsCheckSettingsImport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EmailsCheckSettingsImport} obj Optional instance to populate.
   * @return {module:model/EmailsCheckSettingsImport} The populated <code>EmailsCheckSettingsImport</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EmailsCheckSettingsImport();
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} enabled
 */
EmailsCheckSettingsImport.prototype.enabled = undefined;

